import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiSearch, FiTrendingUp, FiBookOpen, FiFileText } from 'react-icons/fi';
import siteData from '../data/siteData';
import ScrollReveal from './ScrollReveal';

const ICONS = [FiSearch, FiTrendingUp, FiBookOpen, FiFileText];

export default function Services() {
  const cards = siteData.homepage_sections.services_section;

  return (
    <section className="home-services-section">
      {/* Section header */}
      <div className="container home-services-header">
        <ScrollReveal>
          <span className="section-badge">What We Do</span>
          <h2 className="section-title">Our Core Services</h2>
          <div className="gold-divider" />
          <p className="section-subtitle">
            We deliver comprehensive financial, tax, and advisory services with a commitment to excellence and integrity.
          </p>
        </ScrollReveal>
      </div>

      {/* Cards grid */}
      <div className="container home-services-grid">
        {cards.map((card, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
            <ScrollReveal key={card.title} delay={i * 100} className="home-services-card-wrapper">
              <Link
                to={card.read_more_link}
                className="home-services-card"
              >
                <div className="home-services-card-icon">
                  <Icon size={28} />
                </div>
                <h3 className="home-services-card-title">{card.title}</h3>
                <p className="home-services-card-desc">{card.description}</p>
                <span className="home-services-card-link">
                  Read More <FiArrowRight size={14} />
                </span>
                <div className="home-services-card-bg" />
              </Link>
            </ScrollReveal>
          );
        })}
      </div>


    </section>
  );
}
